import(/* webpackMode: "eager" */ "/vercel/path0/app/seo-analyzer/page.tsx");
